import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const DatabaseService = {
  getPagedResult({
    page,
    limit,
    dateFrom,
    dateTo,
    viewMode
  }) {
    return Http.get(`/statistic-student?page=${page}&limit=${limit}&dateFrom=${dateFrom}&dateTo=${dateTo}&viewMode=${viewMode}`);
  },
};

export default DatabaseService;
